import { EnvConfig } from "../../types";

export const customerConfigProd: EnvConfig = {
  MODULE_NAME: "customer",
  MODULE_ENV: "prod",
  LD_CLIENT_SIDE_ID: "63583be10d275b11a1f32f7c",
  MANIFEST_URL:
    "https://pipelines.app.coxautoinc.com/module-federation.manifest.json"
};
